
document.addEventListener('DOMContentLoaded', function () {
    $('.words_game_box .game_inner table td').click(function () {
        $('.words_game_box .game_inner table td').removeClass('active');
        if ($(this).find('input').length > 0) {
            // 当前行选中
            let row_index = $(this).index();
            for (let i = row_index; i > -1; i--) {
                if ($(this).parents('tr').find('td').eq(i).html() != '') {
                    $(this).parents('tr').find('td').eq(i).addClass('active');
                } else {
                    break;
                }
            }
            for (let i = row_index; i < 30; i++) {
                if ($(this).parents('tr').find('td').eq(i).html() != '') {
                    $(this).parents('tr').find('td').eq(i).addClass('active');
                } else {
                    break;
                }
            }
            // 当前列选中
            let colunm_index = $(this).parents('tr').index();
            for (let i = colunm_index; i > -1; i--) {
                if ($(this).parents('tbody').find('tr').eq(i).find('td').eq(row_index).html() != '') {
                    $(this).parents('tbody').find('tr').eq(i).find('td').eq(row_index).addClass('active');
                } else {
                    break;
                }
            }
            for (let i = colunm_index; i < 30; i++) {
                if ($(this).parents('tbody').find('tr').eq(i).find('td').eq(row_index).html() != '') {
                    $(this).parents('tbody').find('tr').eq(i).find('td').eq(row_index).addClass('active');
                } else {
                    break;
                }
            }
        }
    });
    // 答案
    // 2024每行答案
    // let letters = 'WE,PANELM90,DVE,DWEATHER,IRG,TAAMPLIFIER,YDNI,GICN,MOYG,3QPC,0A,BLE'.replace(/,/g, '');
    // 2025每行答案
    let letters = 'W,POWERSUPPLY,A,T,PH,REMERGENCYRADIO,DUMMYLOADR,GSF,RTI,ANTENNATUNER,MTM,MIW,IOA,NNR,GE,CQ,SHORTWAVERADIO,BL,L,E'.replace(/,/g, '');
    function finichFun() {
        $('.words_game_box .game_inner table td input[data-letter]').each(function (index, item) {
            $(item).val(letters[index]);
        });
    }
    function resetFun() {
        $('.words_game_box .game_inner table td input[data-letter]').each(function (index, item) {
            $(item).val('');
        });
    }
    let true_num = 0
    let error_num = 0
    let checkLetter = true;
    let active_td = 0
    let hasTriggeredSuccess = false;
    function checkFun() {
        checkLetter = true;
        true_num = 0
        error_num = 0
        active_td = $('.words_game_box .game_inner table td.active input[data-letter]').length
        $('.words_game_box .game_inner table td input[data-letter]').each(function (index, item) {
            // console.log($(item).val().toUpperCase(), '===', letters[index]);
            if ($(item).val().toUpperCase() != letters[index]) {
                checkLetter = false;
                // 判断选中列
                error_num += 1
            } else {
                true_num += 1
            }
        });
        if (checkLetter && !hasTriggeredSuccess) {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'UdnhiA']);
            hasTriggeredSuccess = true;
        } else {
            $('.error_message .correct span').text(true_num);
            $('.error_message .incorrect span').text(error_num)
            $('.game_inner .errow_dialog').show()
            // setTimeout(() => {
            //     $('.game_inner .errow_dialog').hide()
            // }, 3000);
        }
    }
    $('.words_game_box .check_game').click(function () {
        checkFun();
    });
    $('.words_game_box .reset_game').click(function () {
        resetFun()
        hasTriggeredSuccess = false;
    });


    $('.close-error-btn').click(function() {
        $('.game_inner .errow_dialog').hide()
    })



    // 装饰图片轮播
    const imgs = document.querySelectorAll('.bfcm-carousel-img');
    let currentIndex = 0;

    setInterval(() => {
      imgs[currentIndex].style.opacity = 0;
      currentIndex = (currentIndex + 1) % imgs.length;
      imgs[currentIndex].style.opacity = 1;
    }, 1500);
});
